import React from 'react'

interface DashboardCardProps {
  title?: string
  children: React.ReactNode
  className?: string
  /** Accent: 'mint' | 'lavender' | 'terracotta' | 'rose' for left border */
  accent?: 'mint' | 'lavender' | 'terracotta' | 'rose'
}

const accentBorderClass: Record<NonNullable<DashboardCardProps['accent']>, string> = {
  mint: 'border-l-4 border-l-dashboard-mint',
  lavender: 'border-l-4 border-l-dashboard-lavender',
  terracotta: 'border-l-4 border-l-dashboard-terracotta',
  rose: 'border-l-4 border-l-dashboard-rose',
}

export const DashboardCard: React.FC<DashboardCardProps> = ({
  title,
  children,
  className = '',
  accent,
}) => {
  return (
    <div
      className={`rounded-xl bg-white border border-gray-200 shadow-sm overflow-hidden ${accent ? accentBorderClass[accent] : ''} ${className}`}
    >
      {title ? (
        <div className="px-5 py-4 border-b border-gray-100">
          <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
        </div>
      ) : null}
      <div className="p-5">{children}</div>
    </div>
  )
}

export default DashboardCard
